import _ from "lodash";
import React, { useMemo } from "react";
import { useI18n } from "Hooks";
import { onEnterOrSpaceKeyDown } from "Utils/AccessibilityHelpers";
import { Button, Dropdown, DropdownMenu, IconButton } from "@toddle-edu/ds-web";
import {
  CaretDownFilled,
  CaretClosedFilled,
  CaretOpenedFilled,
} from "@toddle-edu/ds-icons";

// Relative
import classes from "./AIPanelContextSwitch.scss";

const AIPanelContextSwitch = props => {
  const {
    testId = "",
    contextCount = 0,
    sendEvent = _.noop,
    contextOptions = [],
    currentContext = "all",
    showContextList = false,
  } = props;

  const { t } = useI18n();

  const handleContextSwitch = ({ key }) => {
    const newContext = _.find(contextOptions, { key });
    if (!newContext) return;
    sendEvent("SWITCH_CONTEXT", newContext);
  };

  const selectedOption = useMemo(() => {
    return _.find(contextOptions, { key: currentContext }) || {};
  }, [contextOptions, currentContext]);

  const icon = useMemo(() => {
    return showContextList ? <CaretOpenedFilled /> : <CaretClosedFilled />;
  }, [showContextList]);

  return (
    <div
      className={classes.contextSwitchContainer}
      onClick={() => sendEvent("TOGGLE_CONTEXT_LIST")}
      onKeyDown={e =>
        onEnterOrSpaceKeyDown(e, () => sendEvent("TOGGLE_CONTEXT_LIST"))
      }
      role="button"
      tabIndex={0}
    >
      {/* CURRENT CONTEXT SELECTOR */}
      <div
        onClick={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
      >
        <Dropdown
          placement="top"
          getPopupContainer={() => document.body}
          overlay={
            <DropdownMenu
              dsVersion="2.0"
              value={currentContext}
              options={contextOptions}
              onClick={handleContextSwitch}
            />
          }
        >
          <Button
            type="plain"
            size="small"
            dsVersion="2.0"
            variant="neutral"
            rightIcon={<CaretDownFilled />}
            testId={`${testId}-context-switch`}
          >
            {_.get(selectedOption, "label") || t("common:select")}
          </Button>
        </Dropdown>
      </div>

      {/* SELECTED CONTEXT COUNT */}
      <div className={classes.contextSwitchContainerSelectionCount}>
        {contextCount > 0 && (
          <span className="text-body-s">
            {t("common:count_selected", { count: contextCount })}
          </span>
        )}
        <IconButton
          icon={icon}
          type="fill"
          size="small"
          dsVersion="2.0"
          variant="neutral"
        />
      </div>
    </div>
  );
};

export default AIPanelContextSwitch;
